import { useState } from "react";

import { GiHamburgerMenu } from "react-icons/gi";
import logo from "../logo-transparent.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  // const toggleMenu = () => setIsOpen(!isOpen);

  // window.addEventListener('scroll', function () {
  //     const element = document.getElementById('navbar');
  //     const isMobile = window.innerWidth < 768;

  //     if (!element) return;
  //     if (isMobile) {
  //         element.style.backgroundColor = 'white';
  //         return;
  //     }

  //     if (window.scrollY < window.innerHeight * 0.2) {
  //         element.style.backgroundColor = 'rgba(255, 255, 255, 0)';
  //     } else if (window.scrollY > window.innerHeight * 0.2 && window.scrollY < window.innerHeight * 0.4) {
  //         element.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
  //     } else {
  //         element.style.backgroundColor = 'white';
  //     }
  // });

  return (
    <nav
      className="sticky top-0 z-50 pb-3 pt-4"
      id="navbar"
      style={{
        transition: "all 0.5s ease",
        backgroundColor: "white",
      }}
    >
      <div className="flex justify-between items-center px-4">
        <a href="/">
          <img src={logo} alt="logo" className="w-36 h-auto" />
        </a>

        {/* Hamburger Menu Button - visible only on mobile */}
        <button
          className={"lg:hidden text-2xl " + (isOpen ? "rotate-90" : "")}
          onClick={() => setIsOpen(!isOpen)}
          style={{
            transition: "all 0.3s ease",
          }}
        >
          <GiHamburgerMenu />
        </button>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center gap-4">
          <a href="/#home" onClick={() => setIsOpen(false)}>
          <button className="header-link">Domov</button>
          </a>
          <a href="/#newest" onClick={() => setIsOpen(false)}>
          <button className="header-link">Novinky</button>
          </a>
          <a href="/#houses" onClick={() => setIsOpen(false)}>
          <button className="header-link">Domy</button>
          </a>
          <a href="/#cottages" onClick={() => setIsOpen(false)}>
          <button className="header-link">Chaty</button>
          </a>
          <a href="/#other-interesting-properties" onClick={() => setIsOpen(false)}>
          <button className="header-link">Zaujímavé ponuky</button>
          </a>
          <a href="/#all-listings" onClick={() => setIsOpen(false)}>
            <button className="our-offer-button nice-button mb-2 mr-2">
              Naša ponuka
            </button>
          </a>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden ${
          isOpen ? "block" : "hidden"
        } absolute top-full left-0 w-full bg-white shadow-lg`}
      >
        <div className="flex flex-col p-4">
          <a href="/#home" onClick={() => setIsOpen(false)}>
          <button className="header-link text-left py-2">Domov</button>
          </a> 
          <a href="/#newest" onClick={() => setIsOpen(false)}>
          <button className="header-link text-left py-2">Novinky</button>
          </a>
          <a href="/#houses" onClick={() => setIsOpen(false)}>
          <button className="header-link text-left py-2">Domy</button>
          </a>
          <a href="/#cottages" onClick={() => setIsOpen(false)}>
          <button className="header-link text-left py-2">Chaty</button>
          </a>
          <a href="/#other-interesting-properties" onClick={() => setIsOpen(false)}>
          <button className="header-link text-left py-2">Zaujímavé ponuky</button>
          </a>
          <a href="/#all-listings" onClick={() => setIsOpen(false)}>
            <button
              className="nice-button mt-2 z-50"
              style={{
                position: "relative",
                zIndex: 50,
                fontSize: "1.2rem",
                fontWeight: "bold",
                padding: "0.5rem 1rem",
                borderRadius: "0.5rem",
              }}
            >
              Naša ponuka
            </button>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
